import { Flex, MultiSelectProps, Text } from "@mantine/core";
import { forwardRef, useState } from "react";

import { FKInfoLabel, FKMultiSelect } from "@/features/ui/Base/List/CustomFilter/MultiField";
import { IconX } from "@tabler/icons-react";
import { useOperationsMultiAutoComplete, useOperationsMultiCode } from "./multiAuto-useGetOperationsQuery";

interface OperationMultiProps extends React.ComponentPropsWithoutRef<"div"> {
    label: string;
    value: string;
}

export interface OperationsMultiAutoCompleteProps
    extends Partial<MultiSelectProps>,
    Partial<React.RefAttributes<HTMLInputElement>> {
    value: string[];
    onChange?: (e: string[]) => void; // (value: string[]) => React.Dispatch<React.SetStateAction<string>>;
    maxDropdownHeight?: number;
    width?: string;
}

export const OperationsMultiAutoComplete = (
    params: OperationsMultiAutoCompleteProps
) => {
    const {
        value: operations,
        onChange,
        maxDropdownHeight,
        width,
        ...etcParams
    } = params;
    const [focused, setFocused] = useState<boolean>(true);
    const [searchKeyword, setSearchKeyword] = useState<string>("");
    const { data: options } = useOperationsMultiAutoComplete(
        focused,
        searchKeyword
    );
    const { data: initialOptions } = useOperationsMultiCode(
        !!searchKeyword,
        searchKeyword ?? null
    );

    const onChangeHandler = (e: string[]) => {
        onChange && onChange(e);
    };

    const SelectOperation = forwardRef<HTMLDivElement, OperationMultiProps>(
        ({ label: name, value: code, ...others }, ref) => (
            <div ref={ref} {...others}>
                <Flex direction="row" justify="space-between" align="center">
                    <Flex align={"center"}>
                        <Text>{name}</Text>
                        <Text fz="xs">(공정명: {code})</Text>
                    </Flex>
                </Flex>
            </div>
        )
    );

    return (
        <FKMultiSelect
            clearable
            value={operations}
            data={[...(options ?? []), ...(initialOptions ?? [])].reduce(
                (unique: OperationMultiProps[], option: OperationMultiProps) => {
                    return unique.some((u) => u.value === option.value)
                        ? unique
                        : [...unique, option];
                },
                []
            )}
            onChange={onChangeHandler}
            searchable
            itemComponent={SelectOperation}
            searchValue={searchKeyword}
            withinPortal
            onDropdownOpen={() => setFocused(true)}
            onDropdownClose={() => setFocused(false)}
            maxDropdownHeight={maxDropdownHeight ?? 150}
            onSearchChange={setSearchKeyword}
            nothingFound="No Options"
            rightSection={OperationInfo({
                Operation: operations,
                onChange: onChangeHandler,
            })}
            {...etcParams}
        />
    );
};

const OperationInfo = (params: {
    Operation?: string[];
    onChange: (e: string[]) => void
}) => {
    const { Operation, onChange } = params;

    const clearHandler: React.MouseEventHandler<SVGSVGElement> = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onChange([]);
    };

    return Operation?.length ? (
        <FKInfoLabel>
            <IconX size="1rem" onClick={clearHandler} />
        </FKInfoLabel>
    ) : null;
};

